import { func, number, string, object, oneOfType } from 'prop-types'
import { newDateObject } from '../../../../helpers/dateHelpers'
import { isApproval, isTask } from '../../../../helpers/matchers'
import WorkflowPanelApproval from '../../../../PhaseItems/WorkflowPanelApproval'
import WorkflowPanelTask from '../../../../PhaseItems/WorkflowPanelTask'

const normalizeId = (id) => {
  const parsedId = parseInt(id, 10)
  return Number.isNaN(parsedId) ? undefined : parsedId
}

const Item = ({
  currentUser,
  dueDate,
  phaseType,
  id,
  theme,
  ...otherProps
}) => {
  const normalizedId = normalizeId(id)
  const completedAt = otherProps.updated_at
    ? newDateObject(otherProps.updated_at._i)
    : null

  if (isApproval(phaseType)) {
    return (
      <WorkflowPanelApproval
        {...otherProps}
        currentUser={currentUser}
        displayType="default"
        id={normalizedId}
        items={otherProps.items}
        proxyUser={otherProps.proxy_user}
        theme={theme}
        toUser={otherProps.to_user}
      />
    )
  }
  if (isTask(phaseType)) {
    return (
      <WorkflowPanelTask
        {...otherProps}
        checked={otherProps.status === 'complete'}
        completedAt={completedAt}
        currentUser={currentUser}
        dueDate={dueDate}
        id={normalizedId}
        isDueAtDate={true}
        phaseIsComplete={otherProps.isComplete}
        phaseIsCurrent={otherProps.isCurrent}
        theme={theme}
      />
    )
  }

  return null
}

Item.propTypes = {
  currentUser: object,
  dueDate: object,
  id: oneOfType([string, number]),
  onSelectAssignee: func,
  phase: object,
  phaseItem: object,
  phaseType: string,
  theme: string,
  updatePhaseItem: func,
}

export default Item
